<template>
    <v-container
    class="pa-12 fill-height align-start"
    fluid
    > 
        <template v-if="loading">
            <v-overlay :value="loading">
                <v-progress-circular
                    :size="100"
                    color="white"
                    indeterminate
                ></v-progress-circular>
            </v-overlay>
        </template>
        <template v-else>
            <v-row>
                <v-col>
                    <div class="headline">Countries</div>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6" class="d-flex align-center py-4">
                    <v-card width="660" flat color="grey lighten-4">
                        <v-card-text>
                            <v-row class="px-4" align="center">
                                <v-col class="pa-0">
                                    <v-text-field
                                        v-model="newCountryName"
                                        outlined
                                        dense
                                        hide-details
                                        label="Country"
                                        color="primary"
                                        type="text"
                                        class="mr-3"
                                    ></v-text-field>
                                </v-col>
                                <v-col class="pa-0">
                                    <v-text-field
                                        v-model="newCountryIsoCode"
                                        outlined
                                        dense
                                        hide-details
                                        v-mask="'AA'"
                                        label="Country code"
                                        color="primary"
                                        type="text"
                                        class="mr-3"
                                    ></v-text-field>
                                </v-col>
                                <v-col class="pa-0">
                                    <div class="d-flex align-center px-4">
                                        <v-checkbox v-model="newCountryIsStripeAvailable"></v-checkbox>
                                        <span class="subtitle-1">Stripe Available</span>
                                    </div>
                                </v-col>
                                <v-col class="pa-0 flex-shrink-0 flex-grow-0">
                                    <v-btn 
                                        small 
                                        depressed
                                        color="primary"
                                        height="40px" 
                                        :disabled="!newCountryName || !newCountryIsoCode"
                                        @click="createCountry"
                                    >Save</v-btn>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>                    
                </v-col>
            </v-row>            
            <v-card
                outlined
                width="660"
            >
                <template v-if="countries.length > 0">
                    <template v-for="(country, index) in countries">
                        <v-list-item
                            :key="index"
                            class="pa-0"
                        >
                            <v-row justify="space-between" align="center" class="px-4 py-0">
                                <v-col class="py-2">
                                    <span class="subtitle-2">{{ country.name }} <small class="font-weight-medium">({{ country.isoCode }})</small></span>
                                    <v-btn 
                                        small 
                                        depressed 
                                        color="primary" 
                                        class="ml-4" 
                                        v-if="country.hasStates"
                                    >Add states</v-btn>
                                </v-col>
                                <v-col class="text-right py-2">
                                    <v-btn
                                        icon
                                        color="primary"
                                        class="mr-1"
                                        @click="updateCountryEventHandler(country, index)"
                                    ><v-icon>mdi-pencil</v-icon></v-btn>
                                    <v-btn
                                        icon
                                        color="secondary"
                                        @click="deleteCountryEventHandler(country, index)"
                                    ><v-icon>mdi-trash-can</v-icon></v-btn>
                                </v-col>
                            </v-row>
                        </v-list-item>
                        <v-divider
                            v-if="index + 1 < countries.length"
                            :key="'a'+index"
                        ></v-divider>
                    </template>  
                </template>
                <template v-else>
                    <v-card-subtitle>No records</v-card-subtitle>
                </template>
            </v-card>
        </template>
        <!-- Update level bottom sheet -->
        <v-bottom-sheet v-model="updateCountrySheet">
            <v-sheet class="text-center">                
                <v-row no-gutters justify="center" class="py-6">
                    <v-col cols="12" md="8" lg="5">
                        <v-row>
                            <v-col cols="12" md="4" lg="4">
                                <v-text-field
                                    dense
                                    outlined
                                    hide-details
                                    v-model="selectedCountryObject.name"
                                    label="Country name"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="4" lg="4">
                                <v-text-field
                                    dense
                                    outlined
                                    hide-details
                                    v-model="selectedCountryObject.isoCode"
                                    label="Country code"
                                    v-mask="'AA'"
                                ></v-text-field>
                            </v-col>
                             <v-col cols="12" md="4" lg="4">
                                   <div class="d-flex">
                                        <v-checkbox class="checkbox-mt-0" v-model="selectedCountryObject.isStripeAvailable"></v-checkbox>
                                        <span class="subtitle-1 s-pt-4">Stripe Available</span>
                                    </div>
                            </v-col>
                        </v-row>
                        <div class="d-flex">
                            <v-btn 
                                depressed 
                                small 
                                color="primary"
                                @click="updateCountry"
                            >Update</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn
                                text
                                small
                                color="secondary"
                                @click="updateCountrySheet = false"
                            >close</v-btn>
                        </div>
                    </v-col>                                           
                </v-row>              
            </v-sheet>
        </v-bottom-sheet>
        <!-- Delete country -->
        <v-bottom-sheet v-model="deleteCountrySheet">
            <v-sheet class="text-center py-4">
                <div class="py-3">Are you sure you want to delete this country?</div>
                <v-btn
                    text
                    color="secondary"
                    @click="deleteCountry"
                >Yes</v-btn>
                <v-btn
                    text
                    color="primary"
                    @click="deleteCountrySheet = false"
                >No</v-btn>
            </v-sheet>
        </v-bottom-sheet>      
      </v-container>
</template>

<script>
    import { mapGetters } from 'vuex'
    import { mask } from 'vue-the-mask'

    export default {
        name : "countires",
        data: () => ({
            loading: true,
            countries : [],
            newCountryName: '',
            newCountryIsoCode: '',
            newCountryIsStripeAvailable: false,
            newCountryLanguageId: 0,
            selectedCountryObject: {
                index: 0,
                id: 0,
                name: '',
                isoCode: '',
                isStripeAvailabe: false,
                languageId: 0
            },
            deleteCountrySheet: false,
            updateCountrySheet: false,
            snackbar: {
                show: true,
                message: ''
            }
        }),
        directives: {
            mask
        },
        computed: {
            ...mapGetters(['languages', 'defaultLanguage'])
        },    
        mounted() {
            this.fetchCountries()
        },
        methods : {
            async fetchCountries(){
                await this.axios.get('/Country/GetAll', {
                    params: {
                        languageId: this.defaultLanguage.id
                    }
                })
                .then(reseponse => {
                    console.log('countries',reseponse.data.list)
                    this.countries = reseponse.data.list
                })
                .catch(error => { console.log(error) })
                this.loading = false
            },
            createCountry() {
                const data = {
                    name: this.newCountryName,
                    isoCode: this.newCountryIsoCode,
                    isStripeAvailable: this.newCountryIsStripeAvailable,
                    languageId: this.defaultLanguage.id
                }
                this.axios.post('/Country/CreateCountry', data)
                .then(reseponse => {
                    this.countries.push(reseponse.data)
                    this.newCountryName = ''
                    this.newCountryIsoCode = ''
                    this.newCountryIsStripeAvailable = false
                    this.newCountryLanguageId = 0
                    this.snackbar.message = 'Country created successfully'
                    this.$EventBus.$emit('snackbar', this.snackbar)
                })
                .catch(error => { console.log(error.response) })
            },
            deleteCountryEventHandler(country, index) {
                this.deleteCountrySheet = true
                this.selectedCountryObject.index = index
                this.selectedCountryObject.id = country.id
                this.selectedCountryObject.name = country.name
                this.selectedCountryObject.languageId = country.languageId
            },
            deleteCountry() {
                const data = {
                    countryId: this.selectedCountryObject.id,
                }
                this.axios.delete('/Country/Delete', {
                    params: data
                })
                .then(reseponse => {
                    this.countries.splice(this.selectedCountryObject.index, 1)
                    this.deleteCountrySheet = false
                    this.snackbar.message = 'Country deleted successfully'
                    this.$EventBus.$emit('snackbar', this.snackbar)
                })
                .catch(error => { console.log(error) })
            },
            updateCountryEventHandler(country, index){
                this.updateCountrySheet = true
                this.selectedCountryObject.index = index
                this.selectedCountryObject.id = country.id
                this.selectedCountryObject.name = country.name
                this.selectedCountryObject.isoCode = country.isoCode
                this.selectedCountryObject.isStripeAvailable = country.isStripeAvailable
                this.selectedCountryObject.languageId = country.languageId
            },
            updateCountry() {
                const data = {
                    id: this.selectedCountryObject.id,
                    name: this.selectedCountryObject.name,
                    isoCode: this.selectedCountryObject.isoCode,
                    isStripeAvailable: this.selectedCountryObject.isStripeAvailable,
                    languageId: this.selectedCountryObject.languageId
                }
                this.axios.post('/Country/UpdateCountry', data)
                .then(response => {
                    this.updateCountrySheet = false
                    this.countries[this.selectedCountryObject.index] = response.data
                    this.snackbar.message = 'Country updated successfully'
                    this.$EventBus.$emit('snackbar', snackbar)
                })
                .catch(error => { console.log(error) })
            },
        }    
    }
</script>

<style lang="scss" scoped>
.checkbox-mt-0{
    margin-top: 0px !important;
}
.s-pt-4{
    padding-top: 4px !important;
}
</style>